/**
 * @desc loadClientByClientId
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.Client, options?: any) {
  return updateResponse(
    http(URL + `/load/client`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
